import { createSelector } from 'reselect';

const getAnalytics = state => state.analytics;

const AnalyticsSelectors = {
    makeCoreProductInvoice: createSelector([getAnalytics], analytics => analytics.coreProductInvoice),
    makePropertiesReport: createSelector([getAnalytics], analytics => analytics.propertiesReport),
    makeBoostAdReport: createSelector([getAnalytics], analytics => analytics.boostAdReport),
    makeBoostAdPreviews: createSelector([getAnalytics], analytics => analytics.boostAdPreviews),
    makeGraphs: createSelector([getAnalytics], analytics => analytics.graphs),
    makeMultifamilyListings: createSelector([getAnalytics], analytics => analytics.multifamilyListings),
    makeOverviewFilter: createSelector([getAnalytics], analytics => analytics.overviewFilter),
    makeAudienceData: createSelector([getAnalytics], analytics => analytics.audienceData),
    makeCompetitionData: createSelector([getAnalytics], analytics => analytics.competition),
};

export default AnalyticsSelectors;
